module.exports = __webpack_public_path__ + "static/media/18.6e465923.jpg";